import { useEffect } from 'react';

import Portal from '@/components/common/Portal';
import DownloadCertificateModal from '@/components/v2/GraduatePage/DownloadCertificateModal';
import ShareModal from '@/components/v2/GraduatePage/ShareModal';

import * as S from './style';

export default function Template({
  graduateName,
  header,
  body,
  footer,
}: {
  graduateName: string;
  header: React.ReactNode;
  body: React.ReactNode;
  footer: React.ReactNode;
}) {
  useEffect(() => {}, []);

  return (
    <>
      <S.Wrapper>
        <S.Contents>
          {header}
          {body}
        </S.Contents>
        {footer}
      </S.Wrapper>
      <Portal selector='#portal'>
        <ShareModal graduateName={graduateName} />
        <DownloadCertificateModal />
      </Portal>
    </>
  );
}
